/* eslint-disable no-nested-ternary */
import moment from 'moment';
import _ from '../../../utils/lodash';
import { parseDateUtc } from '../../../utils/dates';
import { getAvailableTimeSpansForTreatment, getAvailableTimeSpansForTreatments } from '../../../actions/areas/planner';

export const getSchedulerPeriod = period => {
  if (period === null) {
    const minDate = moment('1900-01-01T00:00:00');
    return {
      startDate: minDate,
      endDate: minDate,
      startHour: 0,
      duration: 0,
      cellLength: 0,
    };
  }

  const startDate = parseDateUtc(period.startDate); // '2020-01-10T08:00:00',
  const endDate = parseDateUtc(period.endDate); // '2020-01-10T08:00:00',

  return {
    startDate,
    endDate,
    startHour: startDate.hour(),
    endHour: endDate.hour(),
    duration: period.duration,
    cellLength: period.cellLength,
  };
};

const getElementAttribute = (element, attrName) => element.getAttribute(attrName);

const getElementProps = element => {
  const returnObject = {
    width: 0,
    height: 0,
  };

  if (element) {
    returnObject.width = element.offsetWidth;
    returnObject.height = element.offsetHeight;
    returnObject.scrollHeight = element.scrollHeight;
    returnObject.scrollWidth = element.scrollWidth;
  }

  return returnObject;
};

export const getElementPropsById = id => {
  const element = document.getElementById(id);
  return getElementProps(element);
};

export const handleScrolls = elementId => {
  const element = document.getElementById(elementId);

  if (element) {
    const rcBody = element.querySelectorAll('.rest-columns > .tbody')[0];
    const fcBody = element.querySelectorAll('.fix-column > .tbody')[0];
    const rcHead = element.querySelectorAll('.rest-columns > .thead')[0];

    if (rcBody) {
      rcBody.addEventListener('scroll', e => {
        fcBody.scrollTop = e.target.scrollTop;
        rcHead.scrollLeft = e.target.scrollLeft;
      });
    }
  }
};

export const getElementPropsByClass = className => {
  const element = document.getElementsByClassName(className);
  return getElementProps(element[0]);
};

export const getElementsByClass = (id, className) => {
  const returnObject = [];

  const rootElement = document.getElementById(id);
  if (rootElement) {
    const elements = rootElement.querySelectorAll(className);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const startDateTime = getElementAttribute(element, 'data-start-datetime');
      const endDateTime = getElementAttribute(element, 'data-end-datetime');
      const duration = getElementAttribute(element, 'data-duration');

      returnObject.push({ startDateTime, endDateTime, duration: parseInt(duration, 10), element });
    }
  }

  return returnObject;
};

export const setElementProp = (element, propName, propValue) => {
  if (element) {
    // eslint-disable-next-line no-param-reassign
    element.style[propName] = propValue;
  }
};

export const removeVisitContent = (element, propName, propValue) => {
  const visitContent = element.getElementsByClassName('visit-content');
  setElementProp(visitContent, propName, propValue);
};

export const addClassToElements = (className, classValue) => {
  const elements = document.getElementsByClassName(className);
  _.each(elements, element => element.classList.add(classValue));
};

export const removeOverlayStyle = className => {
  const elements = document.getElementsByClassName(className);
  _.each(elements, element => element.classList.remove('active-overlay'));
};

export const findByAttrDataIdAndHandleActiveClass = (containerClassName, elementClassName, elementId) => {
  const elementIdAsString = elementId.toString();
  const container = document.getElementsByClassName(containerClassName);
  if (container && container.length > 0) {
    const elements = container[0].querySelectorAll(elementClassName);

    _.each(elements, element => {
      const dataId = element.getAttribute('data-id');
      element.classList.remove('active');
      if (dataId === elementIdAsString) {
        element.classList.add('active');
      }
    });
  }
};

export const resetTimelineActiveClass = (containerClassName, elementClassName) => {
  const container = document.getElementsByClassName(containerClassName);
  if (container && container.length > 0) {
    container[0].classList.remove('active-overlay');
    const elements = container[0].querySelectorAll(elementClassName);
    _.each(elements, element => element.classList.remove('active'));
  }
};

export const setTimelineHeight = (containerId, heightOffset) => {
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  const timeLineHeight = windowHeight - heightOffset;

  const timelineBodyHeightElements = getElementsByClass(containerId, '.tbody');
  _.each(timelineBodyHeightElements, item => setElementProp(item.element, 'height', `${timeLineHeight}px`));

  const timelineColumnsHeightElements = getElementsByClass(containerId, '.rest-columns .tbody');
  _.each(timelineColumnsHeightElements, item => setElementProp(item.element, 'height', `${timeLineHeight + 10}px`));
};

export const getTravelMinutesFromElement = (element, className) => {
  const travelTimeElement = { element: null, duration: 0 };
  const elements = element.querySelectorAll(className);

  if (elements && elements.length > 0) {
    travelTimeElement.element = elements[0];
    travelTimeElement.duration = parseInt(getElementAttribute(elements[0], 'data-duration'), 10);
  }

  return travelTimeElement;
};

export const highlightAvailableSlots = (
  isMultiAssign,
  treatmentInstances,
  model,
  setLoadingTimeSlots,
  getFlag,
  resetTreatmentClickEvent,
  setActiveTreatment,
  getAccessToken,
) => {
  const treatmentCallback = (availableTimeSpans, instance) => {
    const treatment = _.cloneDeep(instance) || {};
    treatment.AvailableTimeSpans = availableTimeSpans;
    setActiveTreatment(treatment);
    setLoadingTimeSlots({ treatmentId: null, timeSlotId: null, value: false });
  };

  const onSuccess = availableTimeSpans => {
    if (isMultiAssign) {
      treatmentInstances.forEach(instance => {
        treatmentCallback(availableTimeSpans, instance);
      });
    } else {
      treatmentCallback(availableTimeSpans, treatmentInstances);
    }
  };

  const getTimeSlots = () =>
    isMultiAssign
      ? getAvailableTimeSpansForTreatments(getAccessToken, model, onSuccess)
      : getAvailableTimeSpansForTreatment(getAccessToken, model, false, onSuccess);

  if (getFlag('isEditMode')) {
    resetTreatmentClickEvent();
    setTimeout(getTimeSlots(), 30);
  } else {
    getTimeSlots();
  }

  if (isMultiAssign) {
    treatmentInstances.forEach(instance => {
      setLoadingTimeSlots({ treatmentId: instance.treatmentId, timeSlotId: instance.timeSlotId, value: true });
    });
  } else {
    setLoadingTimeSlots({
      treatmentId: treatmentInstances.treatmentId,
      timeSlotId: treatmentInstances.timeSlotId,
      value: true,
    });
  }
};
